export default __webpack_public_path__ + "static/media/12.d23562f3.png";